<template>
  <div>
    <!-- type 1 上下结构 2 左右结构 -->
    <div class="news_item" v-if="type == 1" @click="toDetails(newsData)">
      <div class="news_imgwrap">
        <img class="news_img" :src="newsData.image" alt="" />
      </div>
      <div class="news_main">
        <div class="news_title color fb">
          {{ langSet == "cn" ? newsData.title : newsData.en_title }}
        </div>
        <div class="news_con">
          {{ langSet == "cn" ? newsData.desc : newsData.en_desc }}
        </div>
        <div class="news_more flex flex_items_center color">
          {{ langSet == "cn" ? "查看详情" : "Learn More"
          }}<img :src="require('../assets/imgs/more.png')" alt="" />
        </div>
      </div>
    </div>

    <div
      class="news_item news_type flex"
      v-if="type == 2"
      @click="toDetails(newsData)"
    >
      <div class="news_imgwrap">
        <img class="news_img" :src="newsData.image" alt="" />
      </div>
      <div class="news_main">
        <div class="news_title color fb">
          {{ langSet == "cn" ? newsData.title : newsData.en_title }}
        </div>
        <div class="time">{{ newsData.create_time }}</div>
        <div class="news_con">
          {{ langSet == "cn" ? newsData.desc : newsData.en_desc }}
        </div>
        <div class="news_more flex flex_items_center flex_content_end color">
          {{ langSet == "cn" ? "查看详情" : "Learn More"
          }}<img :src="require('../assets/imgs/more.png')" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: Number,
    newsData: Object,
  },
  data() {
    return {
      langSet: "",
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    //25.6.10 跳转详情 dxm
    toDetails(e) {
      console.log(e, "====e");
      if (e.article_type == 1) {
        this.$router.push({
          path: "/newsDetails",
          query: {
            id: e.id,
          },
        });
      } else {
        window.open(this.langSet == "cn" ? e.url : e.en_url, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.news_item {
  color: #555;
  cursor: pointer;
  font-size: 18px;
  line-height: 28px;
  .news_imgwrap {
    width: 100%;
    height: 200px;
    overflow: hidden;
    border: 1px solid #eee;
    border-radius: 20px;
    .news_img {
      width: 100%;
      height: 100%;
      transition: all 0.2s;
    }
    &:hover .news_img {
      transform: scale(1.2);
    }
  }

  .news_main {
    margin-top: 15px;
  }
  .news_title {
    color: #000;
    font-size: 20px;
    margin-bottom: 10px;
    line-height: 30px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .news_con {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }
  .news_more {
    color: #e62344;
    margin-top: 15px;
    img {
      width: 22px;
      height: 22px;
    }
  }
}
.news_type {
  margin-top: 40px;
  .news_imgwrap {
    width: 290px;
    height: 200px;
    border-radius: 0;
  }
  .news_main {
    flex: 1;
    padding-left: 20px;
    margin-top: 10px;
    .news_title {
      font-weight: 500;
    }
    .news_con {
      margin-top: 10px;
    }
    .news_more {
      margin-top: 28px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .news_item {
    font-size: 0.29rem;
    line-height: 0.4rem;
    display: flex;
    .news_imgwrap {
      width: 2.79rem;
      height: 1.92rem;
      border-radius: 0.15rem;
    }
    .news_main {
      margin-top: 0;
      flex: 1;
      margin-left: 0.19rem;
    }
    .news_title {
      color: #000;
      font-size: 0.31rem;
      margin-bottom: 0.13rem;
      line-height: 0.46rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3; /* 限制文本显示为3行，超出部分显示省略号 */
      overflow: hidden;
    }
    .news_con {
      display: none;
    }
    .news_more {
      color: #e62344;
      margin-top: 0;
      img {
        width: 0.31rem;
        height: 0.31rem;
      }
    }
  }
  .news_type {
    margin-top: 0.38rem;
    .news_imgwrap {
      width: 2.79rem;
      height: 1.92rem;
      // border-radius: 0.15rem;
    }
    .news_main {
      flex: 1;
      margin-left: 0.19rem;
      padding-left: 0;
      margin-top: 0;
      .news_title {
        font-size: 0.31rem;
        line-height: 0.46rem;
        font-weight: 500;
      }
      .news_con {
        margin-top: 10px;
      }
      .time {
        display: none;
      }
      .news_more {
        margin-top: 9px;
        justify-content: flex-start;
      }
    }
  }
}
</style>